import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router"

import { App } from "@/app"
import "@/styles/globals.css"

const container = document.getElementById("root")

if (!container) {
  throw new Error("Root element #root is missing from index.html")
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
)
